import { useEffect, useState } from "react";
import { Col, Row, Table } from "reactstrap";
import { getElectricityInfo } from "../../../api/api";
import Spinner from "../../../commons/Spinner";
import { formatNumber, formatPower } from "../../../utils/NumberUtils";

const TableUnit = ({ selected, setSelected, deviceArr, deviceId }) => {
  const [selection, setSelection] = useState(null);
  const [pcsData, setPcsData] = useState(null);
  const [btData, setBtData] = useState(null);
  const authToken = localStorage.getItem("accessToken");
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState();

  useEffect(() => {
    if (selected !== null) {
      setSelection(selected.data.map((item) => item));
    }
    if (deviceArr) {
      let total = 0;
      deviceArr.forEach((value) => {
        if (
          value.device_id.includes("BTPCS") ||
          value.device_id.includes("BAT_PCS")
        ) {
          total += 1;
        }
      });
      setCount(total);
    }
  }, [deviceArr, selected]);

  useEffect(() => {
    setPcsData(null);
    setBtData(null);
    setIsLoading(true);
    const controller = new AbortController();
    const signal = controller.signal;
    const fetchData = async (signal) => {
      selected.data.forEach(async (value, index) => {
        const data = await getElectricityInfo(
          authToken,
          deviceId,
          value,
          signal
        );
        if (!data || data === null || data.comm_error) {
          if (index === 0) {
            setBtData({
              bkup_power_min: "---",
              chrg_curr: "---",
              chrg_power: "---",
              chrg_volt: "---",
              real_power: "---",
              device_id: selected.data[0].device_id,
              dischrg_curr: "---",
              dischrg_power: "---",
              dischrg_volt: "---",
              event_code: "---",
              freq: "---",
              measured_time: "---",
              nominal_capacity: "---",
              power_factor: "---",
              soc: "---",
              soh: "---",
              sys_curr: "---",
              sys_power_received: "---",
              sys_power_send: "---",
              sys_volt: "---",
              time: "---",
              work_status: "---",
              status_code: "---",
            });
          } else {
            setPcsData({
              dc_curr_str1: "---",
              dc_curr_str2: "---",
              dc_volt_mppt1: "---",
              dc_volt_mppt2: "---",
              device_id: selected.data[1].device_id,
              event_code: "---",
              freq: "---",
              measured_time: "-",
              power_factor: "---",
              power_gene_str: "---",
              sys_curr: "---",
              sys_volt: "---",
              time: "---",
              work_status: "---",
              real_power: "---",
              status_code: "---",
            });
          }
        } else {
          if (index === 0) {
            setBtData(data);
          } else {
            setPcsData(data);
          }
        }
        setIsLoading(false);
      });
    };
    const interval = setInterval(() => {
      fetchData(signal);
    }, 60000);
    fetchData(signal);
    return () => {
      clearInterval(interval);
      controller.abort();
    };
    //eslint-disable-next-line
  }, [selected]);

  const options = [];

  for (let i = 1; i <= count; i++) {
    options.push(
      <option key={i} value={"Unit" + i}>
        {"Unit" + i}
      </option>
    );
  }

  const selectUnit = (e) => {
    const selectedUnit = e.target.value.split("Unit")[1];
    const filteredData = deviceArr.filter((item) =>
      item.device_id.includes("A")
        ? item.device_id === "BTPCS" + selectedUnit + "A"
        : item.device_id === "BTPCS" + selectedUnit
    );
    const filteredData1 = deviceArr.filter((item) =>
      item.device_id.includes("A")
        ? item.device_id === "PVPCS" + selectedUnit + "A"
        : item.device_id === "PVPCS" + selectedUnit
    );
    setSelection([...filteredData, ...filteredData1]);
    setSelected({
      data: [...filteredData, ...filteredData1],
      device_id: "Unit",
    });
  };

  const processDeviceId = (device_id) => {
    let unit = device_id.toString().split("BTPCS")
      ? device_id.toString().split("BTPCS")
      : device_id.toString().split("BAT_PCS");
    if (unit[1].includes("A")) {
      return "Unit" + unit[1].split("A")[0];
    } else {
      return "Unit" + unit[1];
    }
  };

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <Row>
          <Col
            md={2}
            lg={2}
            sm={2}
            xl={1}
            className="col-2 d-flex flex-row justify-content-end arrow-menu h-100"
          >
            <div>
              <button className="btn_back" onClick={() => setSelected(null)}>
                <img src="/img/left.png" alt="leftArrow" />
              </button>
            </div>
            <div className="vl"></div>
          </Col>
          <Col md={10} lg={10} sm={10} xl={11} className="col-9">
            <Row className="d-flex flex-row mx-1">
              <div className="dropDown">
                <select
                  type="select"
                  className="btn__dropdown"
                  size="sm"
                  onChange={(e) => {
                    selectUnit(e);
                  }}
                  // value={"Unit" + selected.data[0].device_id.split("BTPCS")[1]}
                  // value={processDeviceId(selected.data[0].device_id)}
                  value={processDeviceId(selected?.data?.[0]?.device_id || "")}
                >
                  {options}
                </select>
              </div>
              <div className="batteryBox">
                <div className="colBorder">
                  <Row className="justify-content-center">
                    <img
                      src="/img/pcsImage.png"
                      alt="pcsImage"
                      className="pv-pcs"
                    />
                  </Row>
                  <Row className="mb-4 mt-4 justify-content-center">
                    {/* {pcsData !== null && <span className="pcsdata">{pcsData.device_id}</span>} */}
                    {selection === undefined ? (
                      <span className="pcsdata">
                        {selected && selected[0].device_id}
                      </span>
                    ) : (
                      <span className="pcsdata">
                        {selection && selection[0].device_id}
                      </span>
                    )}
                  </Row>
                </div>
              </div>
              <Col md={8} sm={10} lg={7} className="individual-battery">
                <div className="table__unit">
                  {btData !== null && (
                    <Table className="power__data ">
                      <tbody>
                        <tr>
                          <td>累計充電電力量</td>
                          <td>{formatPower(btData.chrg_power, 2)}h</td>
                        </tr>
                        <tr>
                          <td>累計放電電力量 </td>
                          <td>{formatPower(btData.dischrg_power, 2)}h</td>
                        </tr>
                        <tr>
                          <td>充放電電力 </td>
                          <td>{formatPower(btData.real_power, 2)}</td>
                        </tr>
                        <tr>
                          <td>力率</td>
                          <td>{formatNumber(btData.power_factor, 3)}</td>
                        </tr>
                        <tr>
                          <td>周波数</td>
                          <td>{formatNumber(btData.freq, 2)}Hz</td>
                        </tr>
                        <tr>
                          <td>充電電圧</td>
                          <td>{formatNumber(btData.chrg_volt, 2)}V</td>
                        </tr>
                        <tr>
                          <td>充電電流</td>
                          <td>{formatNumber(btData.chrg_curr, 2)}A</td>
                        </tr>
                        <tr>
                          <td>放電電圧</td>
                          <td>{formatNumber(btData.dischrg_volt, 2)}V</td>
                        </tr>
                        <tr>
                          <td>放電電流</td>
                          <td>{formatNumber(btData.dischrg_curr, 2)}A</td>
                        </tr>
                        <tr>
                          <td>SOC</td>
                          <td>{btData.soc}%</td>
                        </tr>
                        <tr>
                          <td>SOH</td>
                          <td>{btData.soh}%</td>
                        </tr>
                        <tr>
                          <td>バックアップ電源領域の最小幅</td>
                          <td>{btData.bkup_power_min}%</td>
                        </tr>
                        <tr>
                          <td>名目容量</td>
                          <td>{formatPower(btData.nominal_capacity, 2)}h</td>
                        </tr>
                        <tr>
                          <td>累計系統受電電力量</td>
                          <td>{formatPower(btData.sys_power_send, 2)}h</td>
                        </tr>
                        <tr>
                          <td>累計系統送電電力量</td>
                          <td>{formatPower(btData.sys_power_received, 2)}h</td>
                        </tr>
                        <tr>
                          <td>系統電圧（A相）</td>
                          <td>{formatNumber(btData.sys_volt, 2)}V</td>
                        </tr>
                        <tr>
                          <td>系統電流（A相）</td>
                          <td>{formatNumber(btData.sys_curr, 2)}A</td>
                        </tr>
                        <tr>
                          <td>PCS状態</td>
                          <td>{btData.status_code}</td>
                        </tr>
                        <tr>
                          <td>イベントコード</td>
                          <td>{btData.event_code}</td>
                        </tr>
                        {/* <tr>
                      <td>通信エラー</td>
                      <td>{pcsData.work_status}</td>
                    </tr> */}
                      </tbody>
                    </Table>
                  )}
                </div>
              </Col>
            </Row>

            <Row className="d-flex flex-row mx-1 mt-3">
              <div className="dropDown"></div>
              <div className="batteryBox">
                <div className="colBorder">
                  <Row className="justify-content-center">
                    <img
                      src="/img/pcsImage.png"
                      alt="pv-pcs"
                      className="pv-pcs"
                    />
                  </Row>
                  <Row className="mb-4 mt-4 justify-content-center">
                    {/* {pcsData !== null && <span className="pcsdata">{pcsData.device_id}</span>} */}
                    {selection === undefined ? (
                      <span className="pcsdata">
                        {selected && selected[1].device_id}
                      </span>
                    ) : (
                      <span className="pcsdata">
                        {selection && selection[1].device_id}
                      </span>
                    )}
                  </Row>
                </div>
              </div>
              <Col md={8} sm={10} lg={7} className="individual-battery">
                <div className="table__unit">
                  {selected.data[1].device_maker_type === "SMA" ? (
                    <>
                      {pcsData !== null && (
                        <Table className="power__data">
                          <tbody>
                            <tr>
                              <td>累計発電量 </td>
                              <td>{formatPower(pcsData.power_gene_str, 2)}h</td>
                            </tr>
                            <tr>
                              <td>有効電力 </td>
                              <td>{formatPower(pcsData.real_power, 2)}</td>
                            </tr>
                            <tr>
                              <td>力率</td>
                              <td>{formatNumber(pcsData.power_factor, 3)}</td>
                            </tr>
                            <tr>
                              <td>周波数 </td>
                              <td>{formatNumber(pcsData.freq, 2)}Hz</td>
                            </tr>
                            <tr>
                              <td>DC電圧A</td>
                              <td>{formatNumber(pcsData.dc_volt_mppt1, 2)}V</td>
                            </tr>
                            <tr>
                              <td>DC電圧B</td>
                              <td>{formatNumber(pcsData.dc_volt_mppt2, 2)}V</td>
                            </tr>
                            <tr>
                              <td>DC電流A</td>
                              <td>{formatNumber(pcsData.dc_curr_str1, 2)}A</td>
                            </tr>
                            <tr>
                              <td>DC電流B</td>
                              <td>{formatNumber(pcsData.dc_curr_str2, 2)}A</td>
                            </tr>
                            <tr>
                              <td>系統電圧(A-B線間電圧) </td>
                              <td>{formatNumber(pcsData.sys_volt, 2)}V</td>
                            </tr>
                            <tr>
                              <td>系統電流(A相) </td>
                              <td>{formatNumber(pcsData.sys_curr, 2)}A</td>
                            </tr>
                            <tr>
                              <td>PCS状態</td>
                              <td>{pcsData.status_code}</td>
                            </tr>
                            <tr>
                              <td>イベントコード </td>
                              <td>{pcsData.event_code}</td>
                            </tr>
                            {/* <tr>
                                        <td>通信エラー</td>
                                        <td>{pcsData.work_status}</td>
                                    </tr> */}
                          </tbody>
                        </Table>
                      )}{" "}
                    </>
                  ) : (
                    <>
                      {pcsData !== null && (
                        <Table className="power__data">
                          <tbody>
                            <tr>
                              <td>累計発電量 </td>
                              <td>{formatPower(pcsData.power_gene_str, 2)}h</td>
                            </tr>
                            <tr>
                              <td>有効電力 </td>
                              <td>{formatPower(pcsData.real_power, 2)}</td>
                            </tr>
                            <tr>
                              <td>力率</td>
                              <td>{formatNumber(pcsData.power_factor, 3)}</td>
                            </tr>
                            <tr>
                              <td>周波数 </td>
                              <td>{formatNumber(pcsData.freq, 2)}Hz</td>
                            </tr>
                            <tr>
                              <td>DC電圧1</td>
                              <td>{formatNumber(pcsData.dc_volt_pv1, 2)}V</td>
                            </tr>
                            <tr>
                              <td>DC電圧2</td>
                              <td>{formatNumber(pcsData.dc_volt_pv2, 2)}V</td>
                            </tr>
                            <tr>
                              <td>DC電流1</td>
                              <td>{formatNumber(pcsData.dc_curr_pv1, 2)}A</td>
                            </tr>
                            <tr>
                              <td>DC電流2</td>
                              <td>{formatNumber(pcsData.dc_curr_pv2, 2)}A</td>
                            </tr>
                            <tr>
                              <td>系統電圧(A-B線間電圧)</td>
                              <td>{formatNumber(pcsData.sys_volt, 2)}V</td>
                            </tr>
                            <tr>
                              <td>系統電流(A相)</td>
                              <td>{formatNumber(pcsData.sys_curr, 2)}A</td>
                            </tr>
                            <tr>
                              <td>故障コード </td>
                              <td>{pcsData.event_code}</td>
                            </tr>
                            <tr>
                              <td>アラーム1</td>
                              <td>{pcsData.event_signal}</td>
                            </tr>
                            <tr>
                              <td>アラーム2 </td>
                              <td>{pcsData.event_signal2}</td>
                            </tr>
                            <tr>
                              <td>アラーム3 </td>
                              <td>{pcsData.event_signal3}</td>
                            </tr>
                          </tbody>
                        </Table>
                      )}
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default TableUnit;
